import AbaTypeEnum from '~Api/WarehouseLoanTransactionAba/AbaTypeEnum';
import { IDictionary } from '~utilities/IDictionary';

const abaTypeLabels: IDictionary<string> = {
    [AbaTypeEnum.Fwt1RepaymentPrincipal]: 'FWT1',
    [AbaTypeEnum.Fwt1SellInPrepaidInterest]: 'FWT1',
    [AbaTypeEnum.Fwt2RepaymentPrincipal]: 'FWT2',
    [AbaTypeEnum.Fwt2SellInPrepaidInterest]: 'FWT2',
};

export default abaTypeLabels;